import { AuthService } from 'services';

export default {
  login: async (inn, password, { setUser, setLoading }) => {
    const authService = new AuthService({ setUser });

    setLoading(true);

    const response = await authService.login({ inn, password });

    if (response && response.id) {
      localStorage.setItem('user', JSON.stringify(response));
      setUser(response);
    }

    setLoading(false);
  },

  logout: async ({ setUser, setLoading }) => {
    const authService = new AuthService({ setUser });

    setLoading(true);

    await authService.logout();

    localStorage.removeItem('user');

    setUser(null);

    setLoading(false);
  },

  sendEmail: async (email, { setUser, setLoading }) => {
    const authService = new AuthService({ setUser });

    setLoading(true);

    await authService.sendEmail({ email });

    setLoading(false);
  },

  recoveryPassword: async (newPassword, { setUser, setLoading }) => {
    const authService = new AuthService({ setUser });

    setLoading(true);

    await authService.recoveryPassword({ newPassword });

    setLoading(false);
  },
};
